

























































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
import { RootState } from '@/store/store';
import {
  Invitation,
  Pagination
} from '@/store/modules/admin/types/admin.types';
import { ApiState } from '@/store/types/general.types';
import { ToastProgrammatic as Toast } from 'buefy';
import { isDifferent, isTruthy } from '@/jbi-shared/util/watcher.vue-decorator';
import { AxiosError } from 'axios';
import { get as _get } from 'lodash';
import BasePaginatorHoc from '../../../components/base/BasePaginatorHoc.vue';
import UserInvitationHistoryList from './UserInvitationHistoryList.vue';
import BaseLoading from '../../../components/base/BaseLoading.vue';
import { GetUserInvitationHistoryPayload } from '../../../store/modules/admin/types/admin.types';

@Component({
  components: {
    BasePaginatorHoc,
    UserInvitationHistoryList,
    BaseLoading
  }
})
export default class UserInvitationHistoryModal extends Vue {
  public perPage = 10;
  public page = 1;
  public sortColumn: string = 'invitationDate';
  public sortOrder: 'ASC' | 'DESC' = 'DESC';

  @Prop() public email!: string;

  @State((state: RootState) => state.admin.userInvitations)
  public userInvitations!: Pagination<Invitation>;

  @Action('admin/getUserInvitations')
  public getUserInvitations!: (
    params: GetUserInvitationHistoryPayload
  ) => Promise<void>;

  @State((state: RootState) => state.admin.apiState.getUserInvitations)
  public getUserInvitationsState!: ApiState;

  @State((state: RootState) => state.admin.apiState.removeUserInvitation)
  public removeUserInvitationState!: ApiState;

  get UserInvitationHistoryList() {
    return UserInvitationHistoryList;
  }

  get invitations() {
    if (this.userInvitations) {
      return this.userInvitations.items || [];
    }
    return [];
  }

  get getUserInvitationsParams() {
    return {
      email: this.email,
      page: +this.page,
      limit: +this.perPage,
      sortColumn: this.sortColumn,
      sortOrder: this.sortOrder
    };
  }

  public async mounted() {
    await this.getUserInvitations(this.getUserInvitationsParams);
  }

  public async handleSort(data: any) {
    this.sortColumn = data.sortColumn;
    this.sortOrder = data.sortOrder;

    this.getUserInvitations(this.getUserInvitationsParams);
  }

  public async handlePaginator({
    perPage,
    page
  }: {
    perPage: number;
    page: number;
  }) {
    this.perPage = perPage || this.perPage;
    this.page = page || this.page;

    this.getUserInvitations(this.getUserInvitationsParams);
  }

  @Watch('removeUserInvitationState.success')
  @isDifferent
  @isTruthy
  public onRemoveSuccess() {
    Toast.open({
      queue: true,
      type: 'is-dark',
      position: 'is-top',
      message: `Remove User Invitation Successfully`
    });
    this.getUserInvitations(this.getUserInvitationsParams);
  }

  @Watch('removeUserInvitationState.error')
  @isDifferent
  @isTruthy
  public onRemoveError(error: AxiosError) {
    Toast.open({
      queue: true,
      type: 'is-danger',
      position: 'is-top',
      message: `Error Remove User Invitation. Error: ${_get(
        error.response,
        'data.message'
      )}`
    });
  }
}
